import type { EditorAPI } from '#packages/editorAPI';
import { hoc } from '#packages/util';
import type {
  Dispatch,
  MapDispatchToProps,
  MapStateToProps,
} from 'types/redux';
import { MEDIA_IMAGE_BOOSTER_ORIGIN } from './mediaImageBoosterPanel.constants';
import type {
  BoosterFileDescriptor,
  MediaImageBoosterPanelStateProps,
  MediaImageBoosterPanelDispatchProps,
  MediaImageBoosterPanelOwnProps,
} from './mediaImageBoosterPanel.types';

const mapStateToProps: MapStateToProps<
  MediaImageBoosterPanelStateProps,
  MediaImageBoosterPanelOwnProps
> = (
  { editorAPI }: { editorAPI: EditorAPI },
  { compRef }: MediaImageBoosterPanelOwnProps,
) => ({
  instanceToken: editorAPI.platform.getAppDataByApplicationId(`-666`).instance,
  metaSiteId: editorAPI.dsRead.generalInfo.getMetaSiteId(),
  fileId: editorAPI.components.data.get(compRef).uri,
});

const getEditorAPI = (
  dispatch: unknown,
  getState: unknown,
  { editorAPI }: { editorAPI: EditorAPI },
): EditorAPI => editorAPI;

const mapDispatchToProps: MapDispatchToProps<
  MediaImageBoosterPanelDispatchProps,
  MediaImageBoosterPanelOwnProps
> = (dispatch: Dispatch, { compRef }: MediaImageBoosterPanelOwnProps) => {
  const editorAPI: EditorAPI = dispatch(getEditorAPI);

  const closePanel = () => {
    editorAPI.panelManager.closePanelByName(
      'panels.focusPanels.mediaImageBooster',
      'X',
    );
  };

  const onSave = (fileDescriptor: BoosterFileDescriptor) => {
    closePanel();
    const { displayName, id, width, height, animated } = fileDescriptor;
    editorAPI.mediaServices.updateWPhotoCompData(
      compRef,
      { width, height, id, name: displayName, hasAnimation: animated },
      'booster',
      MEDIA_IMAGE_BOOSTER_ORIGIN,
    );
  };

  return {
    onSave,
    closePanel,
  };
};

export const connectMediaImageBoosterPanel = hoc.connect(
  hoc.STORES.EDITOR_API,
  mapStateToProps,
  mapDispatchToProps,
);
